import React, { useState, useEffect } from "react";
import { ref, onValue } from "firebase/database";
import { db } from "../firebase";
import {
  FaCommentAlt,
  FaPhoneAlt,
  FaCircleNotch,
  FaBullseye,
  FaUsers,
  FaArchive,
  FaRegEdit,
  FaImage,
  FaCog,
  FaMoon,
  FaSun,
  FaUserCircle,
  FaShieldAlt,
  FaLifeRing
} from "react-icons/fa";

function LeftBar({ currentUser, theme, toggleTheme, activeTab, setActiveTab }) {
  const [totalUnread, setTotalUnread] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (!currentUser) return;
    const chatsRef = ref(db, "chats");
    
    const unsubscribeChats = onValue(chatsRef, (snapshot) => {
      const data = snapshot.val();
      if (!data) {
        setTotalUnread(0);
        return;
      }
      
      let count = 0;
      Object.values(data).forEach(chat => {
        const unread = chat?.participants?.[currentUser.uid]?.unreadCount || 0;
        count += unread;
      });
      setTotalUnread(count);
    });

    const adminRef = ref(db, `users/${currentUser.uid}/isAdmin`);
    const unsubscribeAdmin = onValue(adminRef, (snapshot) => {
      setIsAdmin(!!snapshot.val());
    });

    return () => {
      unsubscribeChats();
      unsubscribeAdmin();
    };
  }, [currentUser]);
  return (
    <div className="leftbar">
      <div className="leftbar-top">
        <div className={`left-icon-wrapper nav-chat ${activeTab === 'chats' ? 'active' : ''}`} onClick={() => setActiveTab("chats")}>
          <FaCommentAlt className="left-icon" title="Chats" />
          <span className="left-nav-label">Chats</span>
          {totalUnread > 0 && <span className="icon-badge badge-green">99+</span>}
        </div>

        <div className="left-icon-wrapper" onClick={() => setActiveTab("calls")}>
          <FaPhoneAlt className={`left-icon ${activeTab === "calls" ? "active" : ""}`} title="Calls" />
        </div>

        <div className={`left-icon-wrapper nav-updates ${activeTab === 'status' ? 'active' : ''}`} onClick={() => setActiveTab("status")}>
          <FaCircleNotch className="left-icon" title="Updates" />
          <span className="left-nav-label">Updates</span>
        </div>

        <div className="left-icon-wrapper" onClick={() => setActiveTab("communities")}>
          <FaUsers className={`left-icon ${activeTab === "communities" ? "active" : ""}`} title="Communities" />
        </div>

        <div 
          className={`left-icon-wrapper sai-btn nav-ai ${activeTab === 'ai' ? 'active' : ''}`}
          onClick={() => setActiveTab("ai")}
        >
          <FaCircleNotch className="left-icon meta-ai-icon aiPulse" title="Sampark AI" />
          <span className="left-nav-label">AI</span>
        </div>
      </div>

      <div className="leftbar-bottom">
        <div className="left-icon-wrapper">
          <FaArchive className="left-icon" title="Archived" />
        </div>

        <div className="left-icon-wrapper">
          <FaImage className="left-icon" title="Media" />
        </div>

        <div className="left-icon-wrapper" onClick={() => window.location.href = "/support"}>
          <FaLifeRing className="left-icon" title="Help & Support" />
        </div>

        <div className={`left-icon-wrapper nav-settings ${activeTab === 'settings' ? 'active' : ''}`} onClick={() => setActiveTab("settings")}>
          <FaCog className="left-icon" title="Settings" />
          <span className="left-nav-label">Settings</span>
        </div>

        {isAdmin && (
          <div className="left-icon-wrapper" onClick={() => window.location.href = "/admin"}>
            <FaShieldAlt className="left-icon admin-icon" title="Admin Panel" style={{ color: '#8b5cf6' }} />
          </div>
        )}
        
        <div className="left-icon-wrapper avatar-leftbar">
          {currentUser && currentUser.photoURL ? (
            <img src={currentUser.photoURL} alt="avatar" />
          ) : (
            <FaUserCircle style={{fontSize: '32px', color: 'var(--icon-color)'}} title="Profile" />
          )}
        </div>
      </div>
    </div>
  );
}

export default LeftBar;
